import {
  FinancialAccountNode,
  OrgNode,
} from '../../../services/orgs/interfaces';
import { Consumer, StripeEnv } from '../../../util/enums';
import { StepperPage } from '../../Stepper';
import { ShowPayable, StripeMetadataInput, SuccessData } from '../../VaultForm';
import { useInsightsSteps } from './useInsightsSteps';
import { useRaiseSteps } from './useRaiseSteps';

export const useSteps = ({
  consumer,
  ...params
}: {
  consumer: Consumer;
  org?: OrgNode;
  payableOrg?: OrgNode;
  currentUserId?: string;
  userKyc?: Kyc;
  provider: VaultProvider;
  onSuccess: (res: SuccessData) => void;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  token: string;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
  showSavePayableCheckbox: ShowPayable;
  financialAccountRoots: FinancialAccountNode[];
  statementDescriptor?: string;
  metadata?: StripeMetadataInput;
  stripeEnv: StripeEnv;
  fundraiserId?: string | null;
  fundraiserSlug?: string | null;
  onBankAccountWidgetFinishClick?: () => void;
  onBankAccountWidgetSkipClick?: () => void;
  onClose?: () => void;
  showRaiseLastStep?: boolean;
  showSubmitForReviewButton: boolean;
}): StepperPage[] => {
  const raiseSteps = useRaiseSteps({ ...params, consumer });
  const insightsSteps = useInsightsSteps({ ...params, consumer });

  return [...raiseSteps, ...insightsSteps];
};
